import { redirectUri } from '../services/auth';

const token = 'token';
const redirectUrl = 'redirect_url';
const refreshToken = 'refresh_token';
const expiredTime = 'expired_time';

export const getAccessToken = (): string => {
  const tokenData = localStorage.getItem(token);
  const expiredTimeToken = getExpiredTime();
  if (!expiredTimeToken || expiredTimeToken < Date.now()) {
    return null;
  }
  return tokenData;
};

export const getRefreshToken = (): string => {
  return localStorage.getItem(refreshToken);
};

export const getExpiredTime = (): number | null => {
  const exp = localStorage.getItem(expiredTime);
  return exp ? Date.parse(exp) : null;
};

export const setAccessToken = (value: string): void => {
  localStorage.setItem(token, value);
};

export const setRefreshToken = (value: string): void => {
  localStorage.setItem(refreshToken, value);
};

export const setExpiredTime = (value = 0): void => {
  const date = new Date();
  date.setSeconds(date.getSeconds() + value);
  localStorage.setItem(expiredTime, date.toLocaleString());
};

export const removeAccessToken = (): void => {
  localStorage.removeItem(token);
  localStorage.removeItem(refreshToken);
  localStorage.removeItem(expiredTime);
};

export const setRedirectUrl = (url: string): void => {
  if (url && !window.location.href.startsWith(redirectUri)) {
    localStorage.setItem(redirectUrl, url);
  }
};

export const getRedirectUrl = (): string => {
  const url = localStorage.getItem(redirectUrl);
  localStorage.removeItem(redirectUrl);
  return url;
};
